export default __webpack_public_path__ + "static/media/Dodgers.e59f72fe.png";